export const SECTOR_PAGE_CONSTANT = {
  FORM_SEARCH: {
    COMPANY_ID: 'companyId',
    SECTOR_NAME: 'sectorName',
    SECTOR_CODE: 'sectorCode',
    SECTOR_ID: 'sectorId',
  },

  FORM_MODAL: {
    MODAL_COMPANY_ID: 'companyIdModal',
    MODAL_SECTOR_NAME: 'sectorNameModal',
    MODAL_SECTOR_CODE: 'sectorCodeModal',
    MODAL_SECTOR_ID: 'sectorIdModal',
  },

  TITLE: {
    NO: 'NO',
    COMPANY_ID: '会社',
    SECTOR_CODE: '地区コード',
    SECTOR_NAME: '地区名',
    SEARCH_SECTOR: '地区',
    ACTION: 'アクション',
  },

  LABEL: {
    COMPANY_ID: '会社',
    SECTOR_CODE: '地区コード',
    SECTOR_NAME: '地区名',
  },
  TABLE_KEY: {
    NO: 'no',
    COMPANY_CODE: 'companyCode',
    SECTOR_CODE: 'sectorCode',
    SECTOR_NAME: 'sectorName',
  },
  MESSAGE: {
    DATA_EXIST: '値はすでに存在しています。',
    NOT_FOUND_SECTOR:
      '他の人がデータを更新したため、更新できません。 データベースからデータをリロードしてください。',
  },
};

export const HEIGHT_TABLE_SCROLL = 685;
export const MAX_LENGTH_5 = 5;
export const MAX_LENGTH_50 = 50;
